import { render, staticRenderFns } from "./ShopHeader.vue?vue&type=template&id=ddd863a2&scoped=true&"
import script from "./ShopHeader.vue?vue&type=script&lang=ts&"
export * from "./ShopHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ShopHeader.vue?vue&type=style&index=0&id=ddd863a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd863a2",
  null
  
)

export default component.exports